import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {PricingsModel, GenerateAgreementModel, PricingsCreateModel} from "./pricings.model";
import {FilesModel} from "../files/files.model";

@Injectable()
export class PricingsService implements IDataModel {

    private API_ROOT:string = '/clients/pricings';
    private get_client_id: Function;

    constructor(private http:Http) {
    }

    public setClientIdGetter(f: Function) {
        this.get_client_id = f;
    }

    getList(filter?:IDataFilter): Observable<ListResponseModel<PricingsModel>>  {
        if (this.get_client_id) {
            return this.getListByClient(this.get_client_id(), filter);
        }
        let params:URLSearchParams = new URLSearchParams();

        if (filter) {
            for (let key in filter) {

                if (key == 'fields') {
                    for (let key in filter.fields) {
                        let fieldName = Object.keys(filter.fields[key])[0];
                        params.set(fieldName, filter.fields[key][fieldName]);
                    }
                } else {
                    params.set(key, filter[key] === null ? 'null' : filter[key]);
                }
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<PricingsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/pricings`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getListByClientByDebts(clientId: any): any
    {
        return this.http
            .get(`/clients/${clientId}/pricings-by-debts`)
            .map(res => res.json());
    }

    getCalculatorByClient(clientId:number, filter?:IDataFilter): Observable<ResponseModel<any>>  {
        let params:URLSearchParams = new URLSearchParams();

        if (filter) {
            for (let key in filter) {

                if (key == 'fields') {
                    for (let key in filter.fields) {
                        let fieldName = Object.keys(filter.fields[key])[0];
                        params.set(fieldName, filter.fields[key][fieldName]);
                    }
                } else {
                    params.set(key, filter[key] === null ? 'null' : filter[key]);
                }
            }
        }

        return this.http
            .get(`/clients/${clientId}/calculator`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOne(id:number):Observable<ResponseModel<PricingsModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:PricingsCreateModel): Observable<ResponseModel<PricingsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    generateAgreement(id:number, fields:GenerateAgreementModel) : Observable<ResponseModel<FilesModel>> {
        return this.http.post(`${this.API_ROOT}/${id}/agreement`, fields).map((res) => res.json());
    }

    edit(id:number, fields: any): Observable<ResponseModel<PricingsModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/pricings/pricings.service.ts